import React from 'react';
import i18next from 'i18next';
import SubpageBlue from '../../SubpageBlue';
import Textbox from '../../../../AutostadtTabComponents/Tiles/Textbox';
import { Trans } from 'react-i18next';

export default function OnlineCheckIn() {
    return (
        <SubpageBlue
            title={i18next.t('OnlineCheckInTitle')}
            headerChildren={
                <p className='body large'>
                    <Trans
                        i18nKey='OnlineCheckInSubline'
                        components={{
                            br: <br />,
                        }}
                    />
                </p>
            }
        >
            <Textbox
                text={i18next.t('OnlineCheckInText')}
                buttonText={i18next.t('ToOnlineCheckInBtn')}
                color='white'
                svg='as-info'
                onClick={() => {
                    window.open('https://www.autostadt.de/checkin', '_blank', 'noopener,noreferrer');
                }}
            />
        </SubpageBlue>
    );
}
